import { myapiHost } from '@/conf/env'
import { getJSON } from '@/utils/request'

// 收益记录
export type Record = {
  id: number;
  companyName: string; // 商户名称
  order_no: string;
  description: string;
  bonus: number; // 奖励金额（元）
  date: string; // 入驻时间（文本，原样展示）
}

type DataRecords = {
  items: Record[];
  totalCount: number;
  totalAmount: number;
}

export async function find(params: string) {
  return getJSON<DataRecords>(`${ myapiHost }/income/list`, {
    params,
    withCredentials: true,
  })
}



export default {
  find,
}
